import { lineNumberTransformer } from '@/components/ai-elements/line-number-transformer'
import { type BundledLanguage, codeToHtml, type ShikiTransformer } from 'shiki'

export async function highlightCode(code: string, language: BundledLanguage, showLineNumbers = false) {
  const transformers: ShikiTransformer[] = showLineNumbers ? [lineNumberTransformer] : []

  return await Promise.all([
    codeToHtml(code, {
      lang: language,
      theme: 'one-light',
      transformers,
    }),
    codeToHtml(code, {
      lang: language,
      theme: 'one-dark-pro',
      transformers,
    }),
  ])
}
